import { render, staticRenderFns } from "./skillConfig.vue?vue&type=template&id=8d7eae1a&scoped=true&"
import script from "./skillConfig.vue?vue&type=script&lang=js&"
export * from "./skillConfig.vue?vue&type=script&lang=js&"
import style0 from "./skillConfig.vue?vue&type=style&index=0&id=8d7eae1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7eae1a",
  null
  
)

export default component.exports